import { useEffect } from "react";

const useOnClickOutsideMultiple = (refs, callback = () => void 0, ...dependencies) => {
    useEffect(() => {
        function handleClickOutside(event) {
            // Filter out undefined/null refs and check if click is outside all valid refs
            const validRefs = refs.filter(ref => ref && ref.current);
            const clickedOutsideAll = validRefs.every(ref => !ref.current.contains(event.target));
            
            if (validRefs.length > 0 && clickedOutsideAll) {
                callback();
            } 
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [...refs, ...dependencies]);
}
  
export default useOnClickOutsideMultiple;